//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  data () {
    var checkPassword = (rule, value, callback) => {
      const passwordReg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,18}$/ // 校验密码6-18位
      if (!value) {
        return callback(new Error('请设置密码'))
      }
      setTimeout(() => {
        if (passwordReg.test(value)) {
          callback()
        } else {
          callback(new Error('密码须包含数字、字母两种元素，且密码位数为6-16位'))
        }
      }, 100)
    }
    var checkcPassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请设置密码'))
      }
      if (this.dataForm.newpassword !== value) {
        callback(new Error('两次密码输入不一致！'))
      } else {
        callback()
      }
    }
    return {
      registing: false,
      dataForm: {
        username: '',
        oldpassword: '',
        newpassword: '',
        cpassword: ''
      },
      rules: {
        newpassword: [
          { required: true, message: '请输入密码', trigger: 'blur' }, { validator: checkPassword, trigger: 'blur' }],
        cpassword: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: checkcPassword, trigger: 'blur' }]
      },
      pwdType: 'password',
      eyeType: 'el-input__icon el-icon-view'

    }
  },
  methods: {
    handleSubmit (event) {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.registing = true
          let params = {
            UserName: this.dataForm.username,
            OldPassword: this.dataForm.oldpassword,
            NewPassword: this.dataForm.newpassword
          }
          this.$api.adminChangePassword(params).then(res => {
            if (res.Status === 1) {
              this.registing = false
              sessionStorage.removeItem('adminuser')
              this.$router.push({ path: '/admin/' })
            } else {
              this.registing = false
              this.$alert(res.Message, '错误', {
                confirmButtonText: '确定'
              })
            }
          })
        } else {
          this.registing = false
          this.$alert('修改失败', 'info', {
            confirmButtonText: 'ok'
          })
        }
      })
    },
    showPassword (event) {
      if (this.pwdType === 'password') {
        this.pwdType = 'text'
        this.eyeType = 'el-input__icon el-icon-loading'
      } else {
        this.pwdType = 'password'
        this.eyeType = 'el-input__icon el-icon-view'
      }
    }
  },
  mounted: function () {
    let user = sessionStorage.getItem('adminuser')

    if (user) {
      this.dataForm.username = user
    }
  }
}



// WEBPACK FOOTER //
// ./src/admin/modifypassword.vue